import { Controller } from 'stimulus';

class Share extends Controller {
  connect() {
    if (!navigator.share) {
      this.element.style.display = 'none';
    }
  }

  onClick() {
    const title = this.data.get('title');
    const text = this.data.get('text');
    const url = this.data.get('url');

    navigator.share({
      title,
      text,
      url,
    })
      .then(() => {
        //
      })
      .catch(() => {});
  }
}

Share.targets = [
  //
];

export default Share;
